// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useSelector, useDispatch } from "react-redux";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import { toast } from "react-toastify";
// import "../assets/Cibil/CibilReport.css";

// export default function EquafixCibilReport() {
//   const dispatch = useDispatch();
//   const { profile } = useSelector((state) => state.userProfile);

//   const [reports, setReports] = useState([]);
//   const [search, setSearch] = useState("");
//   const [uid, setUid] = useState("");

//   const [loading, setLoading] = useState(false);
//   const [loadingMore, setLoadingMore] = useState(false);

//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const limit = 10;

//   // 1. Initial Load: Fetch Profile
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   // 2. Fetch Wallet Info once Profile is available
//   useEffect(() => {
//     if (profile?.superAdminId) {
//       fetchWalletInfo();
//     }
//   }, [profile?.superAdminId]);

//   // 3. Fetch Sessions once UID is updated
//   useEffect(() => {
//     if (uid) {
//       fetchSessions(1, search);
//     }
//   }, [uid]);

//   // Combined fetch function handling page jumps and search queries
//   const fetchSessions = async (pageNumber = 1, searchText = "") => {
//     if (!uid) return;
//     try {
//       setLoading(true);
//       const res = await axios.get("https://payyug.in/api/api/credit-sessions", {
//         params: {
//           uid,
//           page: pageNumber,
//           limit,
//           fullName: searchText,
//         },
//       });

//       setReports(res.data.data || []);
//       setTotalPages(res.data.totalPages || 1);
//       setTotalRecords(res.data.totalRecords || 0);
//       setPage(pageNumber);
//     } catch (err) {
//       toast.error("Failed to load reports");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchWalletInfo = async () => {
//     try {
//       const res = await axios.get(
//         `https://payyug.in/api/cibil-profile-optional?superAdminId=${profile.superAdminId}`
//       );
//       const data = res.data.data;
//       if (data?.uid) {
//         setUid(data.uid);
//       }
//     } catch (e) {
//       toast.error("Failed to load wallet info");
//     }
//   };

//   // Pagination Handler for Next/Prev/Page Numbers
//   const handlePageChange = (targetPage) => {
//     if (targetPage < 1 || targetPage > totalPages || targetPage === page) return;
//     fetchSessions(targetPage, search);
//   };

//   // Optional: Keeping 'Load More' (Append functionality) dynamic if you need it
//   const loadMore = async () => {
//     if (page >= totalPages || !uid) return;

//     try {
//       const nextPage = page + 1;
//       setLoadingMore(true);

//       const res = await axios.get("https://payyug.in/api/api/credit-sessions", {
//         params: {
//           uid: uid, // Dynamically using uid state now instead of hardcoded string
//           page: nextPage,
//           limit,
//           fullName: search,
//         },
//       });

//       setReports((prev) => [...prev, ...(res.data.data || [])]);
//       setPage(nextPage);
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to load more reports");
//     } finally {
//       setLoadingMore(false);
//     }
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "REPORT_FETCHED": return "#4caf50";
//       case "CONSENT_COMPLETED": return "#2196f3";
//       case "SESSION_CREATED": return "#ff9800";
//       case "FAILED": return "#f44336";
//       default: return "#757575";
//     }
//   };

//   const handlePdf = async (session) => {
//     try {
//       if (!session.transactionId) {
//         toast.error("Transaction ID not available");
//         return;
//       }

//       switch (session.status) {
//         case "SESSION_CREATED":
//           toast.warning("Session created but consent not completed");
//           return;
//         case "INITIATED":
//           toast.warning("Consent not completed");
//           return;
//         case "IN_PROGRESS":
//           toast.warning("Verification in progress");
//           return;
//         case "FAILED":
//           toast.error("Verification failed");
//           return;
//         case "REPORT_FETCHED":
//           if (session.pdfUrl) {
//             window.open(session.pdfUrl, "_blank");
//           }
//           return;
//         default:
//           break;
//       }

//       const res = await axios.post(
//         "https://payyug.in/api/credit/fetch",
//         { transactionId: session.transactionId },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       if (res.status === 200) {
//         const pdfUrl = res.data.pdfUrl;
//         setReports((prev) =>
//           prev.map((item) =>
//             item.transactionId === session.transactionId
//               ? { ...item, pdfUrl, status: "REPORT_FETCHED" }
//               : item
//           )
//         );
//         window.open(pdfUrl, "_blank");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to fetch report");
//     }
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     fetchSessions(1, search); // Search starts fresh from Page 1
//   };

//   // Generate page number buttons helper array
//   const renderPageNumbers = () => {
//     const pages = [];
//     for (let i = 1; i <= totalPages; i++) {
//       pages.push(
//         <button
//           key={i}
//           onClick={() => handlePageChange(i)}
//           style={{
//             margin: "0 4px",
//             padding: "5px 10px",
//             backgroundColor: page === i ? "#0056b3" : "#f0f0f0",
//             color: page === i ? "#fff" : "#000",
//             border: "1px solid #ccc",
//             borderRadius: "4px",
//             cursor: "pointer"
//           }}
//         >
//           {i}
//         </button>
//       );
//     }
//     return pages;
//   };

//   return (
//     <div className="cibil-report-container">
//       <h1>Credit Report History</h1>

//       {/* <form onSubmit={handleSearch} style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
//         <input
//           type="text"
//           placeholder="Search by name..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />
//         <button type="submit">Search</button>
//       </form> */}

//       <div style={{ marginBottom: 20, fontWeight: 600 }}>
//         Total Reports : {totalRecords}
//       </div>

//       <table className="cibil-wrap-table">
//         <thead>
//           <tr>
//             <th>#</th>
//             <th>Name</th>
//             <th>Mobile</th>
//             <th>Credit Score</th>
//             <th>Status</th>
//             <th>Date</th>
//             <th>Action</th>
//           </tr>
//         </thead>

//         <tbody>
//           {loading ? (
//             <tr>
//               <td colSpan="7">Loading...</td>
//             </tr>
//           ) : reports.length === 0 ? (
//             <tr>
//               <td colSpan="7">No Records Found</td>
//             </tr>
//           ) : (
//             reports.map((item, index) => (
//               <tr key={item.id || index}>
//                 <td>{(page - 1) * limit + index + 1}</td>
//                 <td>{item.fullName}</td>
//                 <td>{item.mobileNumber}</td>
//                 <td>{item.creditScore || "-"}</td>


//               <td>
//   <span
//     style={{
//       padding: "5px 10px",
//       borderRadius: "6px",
//       color: "#fff",
//       fontSize: "12px",
//       backgroundColor:
//         item.status === "REPORT_FETCHED" ||
//         item.report_fetch_status === "CONSENT_COMPLETED"
//           ? "#28a745"
//           : "#dc3545",
//     }}
//   >
//     {item.status === "REPORT_FETCHED" ||
//     item.report_fetch_status === "CONSENT_COMPLETED"
//       ? "Download"
//       : "Not Found"}
//   </span>
// </td>



//                 <td>
//                   {item.createdAt
//                     ? new Date(item.createdAt).toLocaleDateString("en-GB")
//                     : "-"}
//                 </td>
//                 <td>
//                <button
//   onClick={() =>  (item.status === "REPORT_FETCHED" || item.status === "CONSENT_COMPLETED") ? handlePdf(item) : null}
//   className={`report-btn ${
//     (item.status === "REPORT_FETCHED" || item.status === "CONSENT_COMPLETED") ? "download" : "Nt Found"
//   }`}
// >
//   {(item.status === "REPORT_FETCHED" || item.status === "CONSENT_COMPLETED") ? (
//     <>
//        ⬇️ Download Report
//     </>
//   ) : (
//     <>
//      Not Found
//     </>
//   )}
// </button>
//                 </td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>

//       {/* Structured Modern Web Pagination Controls */}
//       {totalPages > 1 && (
//         <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px", gap: "5px" }}>
//           <button 
//             disabled={page === 1} 
//             onClick={() => handlePageChange(page - 1)}
//             style={{ padding: "5px 10px", cursor: page === 1 ? "not-allowed" : "pointer" }}
//           >
//             Prev
//           </button>
          
//           {renderPageNumbers()}

//           <button 
//             disabled={page === totalPages} 
//             onClick={() => handlePageChange(page + 1)}
//             style={{ padding: "5px 10px", cursor: page === totalPages ? "not-allowed" : "pointer" }}
//           >
//             Next
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }



























import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";
import "../assets/Cibil/CibilReport.css";

export default function EquafixCibilReport() {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  const [reports, setReports] = useState([]);
  const [search, setSearch] = useState("");
  const [uid, setUid] = useState("");

  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const limit = 10;

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (profile?.superAdminId) {
      fetchWalletInfo();
    }
  }, [profile?.superAdminId]);

  useEffect(() => {
    if (uid) {
      fetchSessions(1, search);
    }
  }, [uid]);

  const fetchSessions = async (pageNumber = 1, searchText = "") => {
    if (!uid) return;
    try {
      setLoading(true);
      const res = await axios.get("https://payyug.in/api/api/credit-sessions", {
        params: {
          uid,
          page: pageNumber,
          limit,
          fullName: searchText,
        },
      });

      setReports(res.data.data || []);
      setTotalPages(res.data.totalPages || 1);
      setTotalRecords(res.data.totalRecords || 0);
      setPage(pageNumber);
    } catch (err) {
      toast.error("Failed to load reports");
    } finally {
      setLoading(false);
    }
  };

  const fetchWalletInfo = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api/cibil-profile-optional?superAdminId=${profile.superAdminId}`
      );
      const data = res.data.data;
      if (data?.uid) {
        setUid(data.uid);
      }
    } catch (e) {
      toast.error("Failed to load wallet info");
    }
  };

  const handlePageChange = (targetPage) => {
    if (targetPage < 1 || targetPage > totalPages || targetPage === page) return;
    fetchSessions(targetPage, search);
  };

  const handlePdf = async (session) => {
    try {
      if (!session.transactionId) {
        toast.error("Transaction ID not available");
        return;
      }

      switch (session.status) {
        case "SESSION_CREATED":
          toast.warning("Session created but consent not completed");
          return;
        case "INITIATED":
          toast.warning("Consent not completed");
          return;
        case "IN_PROGRESS":
          toast.warning("Verification in progress");
          return;
        case "FAILED":
          toast.error("Verification failed");
          return;
        case "REPORT_FETCHED":
          if (session.pdfUrl) {
            window.open(session.pdfUrl, "_blank");
          }
          return;
        default:
          break;
      }

      const res = await axios.post(
        "https://payyug.in/api/credit/fetch",
        { transactionId: session.transactionId },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.status === 200) {
        const pdfUrl = res.data.pdfUrl;
        setReports((prev) =>
          prev.map((item) =>
            item.transactionId === session.transactionId
              ? { ...item, pdfUrl, status: "REPORT_FETCHED" }
              : item
          )
        );
        window.open(pdfUrl, "_blank");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch report");
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchSessions(1, search);
  };

  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`page-num-btn ${page === i ? "active" : ""}`}
        >
          {i}
        </button>
      );
    }
    return pages;
  };



  

  return (
    <div className="cibil-report-container">
      <h1>Credit Report History</h1>

      <div className="cibil-wrap-header">
        <div style={{ fontWeight: 600, color: "#334155" }}>
          Total Reports : {totalRecords}
        </div>
      </div>

      {/* Added the wrapper container to keep scrolling safe */}
      <div className="cibil-wrap-table-wrapper">
        <table className="cibil-wrap-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>Credit Score</th>
              <th>Status</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" style={{ textAlign: "center", padding: "30px" }}>Loading...</td>
              </tr>
            ) : reports.length === 0 ? (
              <tr>
                <td colSpan="7" style={{ textAlign: "center", padding: "30px" }}>No Records Found</td>
              </tr>
            ) : (
              reports.map((item, index) => {
                const isAvailable =
                  item.status === "REPORT_FETCHED" ||
                  item.status === "CONSENT_COMPLETED";

                return (
                  <tr key={item.id || index}>
                    <td>{(page - 1) * limit + index + 1}</td>
                    <td>{item.fullName}</td>
                    <td>{item.mobileNumber}</td>
                    <td>{item.creditScore || "-"}</td>
                    <td>
                      <span
                        style={{
                          padding: "5px 10px",
                          borderRadius: "6px",
                          color: "#fff",
                          fontSize: "12px",
                          fontWeight: "600",
                          backgroundColor: isAvailable ? "#28a745" : "#dc3545",
                        }}
                      >
                        {isAvailable ? "Report Fetch" : "Not Found"}
                      </span>
                    </td>
                    <td>
                      {item.createdAt
                        ? new Date(item.createdAt).toLocaleDateString("en-GB")
                        : "-"}
                    </td>
                    <td>
                      {isAvailable ? (
                        <button
                          onClick={() => handlePdf(item)}
                          className="report-btn download-btn"
                        >
                          ⬇️ Download Report
                        </button>
                      ) : (
                        <button
                          className="report-btn disabled-btn"
                          disabled
                        >
                          Not Found
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Structured Modern Web Pagination Controls */}
      {totalPages > 1 && (
        <div className="cibil-pagination">
          <button 
            disabled={page === 1} 
            onClick={() => handlePageChange(page - 1)}
            className="pagination-btn"
          >
            Prev
          </button>
          
          {renderPageNumbers()}

          <button 
            disabled={page === totalPages} 
            onClick={() => handlePageChange(page + 1)}
            className="pagination-btn"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );


}